<template>
  <div>
    <h1 class="text-xl">订单信息</h1>
    <hr class="mt-1 mb-4">

    <Placeholder v-if="!order" />
    <div v-else class="ui form">
      <div class="field">
        <label>
          订单号
        </label>
        <div class="text-xl">
          {{ tid }}
        </div>
      </div>
      <div class="field">
        <label>
          套餐
        </label>
        <div class="text-xl">
          {{ display_name }}
        </div>
      </div>
      <div class="field">
        <label>
          时长
        </label>
        <div class="text-xl">
          {{ order.content.months }}个月
        </div>
      </div>
      <div class="field">
        <label>
          有效期
        </label>
        <div class="text-xl">
          <span v-if="order.paid">
            <template v-if="order.start && order.expire">
              {{ format_time(order.start) }} ~ {{ format_time(order.expire) }}
            </template>
            <template v-else>
              无
            </template>
          </span>
          <span v-else>
            支付成功起{{ order.content.months }}个月 （未生效）
          </span>
        </div>
      </div>
      <div class="field">
        <label>
          费用
        </label>
        <div class="text-xl">
          {{ order.amount }}元
        </div>
      </div>
      <div class="field">
        <label>
          状态
        </label>
        <div class="text-xl">
          <strong v-if="order.refund" class="text-secondary">
            <span v-if="order.refund.rejected">
              退款失败 {{ order.refund.reject_reason }}
            </span>
            <span v-else-if="order.refund.refunded">
              已退款 ({{ order.refund.amount.toFixed(2) }}元)
            </span>
            <span v-else>
              退款处理中 ({{ order.refund.amount.toFixed(2) }}元)
            </span>
          </strong>
          <strong v-else-if="order.paid" class="text-success">
            已完成
            <button v-if="order.amount > 0" class="ui blue basic button" @click="show_modal('refund-modal')">
              <Modal id="refund-modal" @cancel="refund_reason=''" @ok="request_refund">
                <div class="ui form">
                  <h5 class="ui header">请告诉我们您希望退款的原因</h5>
                  <div class="my-4">
                    <button v-for="(r, i) in refund_reason_buttons" :key="i"
                            class="ui basic button"
                            @click="refund_reason+='\n'+r+'\n'">
                      {{ r }}
                    </button>
                  </div>
                  <textarea autofocus v-model="refund_reason" rows=5 max-rows=10>
                  </textarea>
                </div>
              </Modal>
              申请退款
            </button>
          </strong>
          <strong v-else>
            待支付
          </strong>
        </div>
      </div>
      <hr class="my-8">
      <template v-if="!order.paid && !order.refund">
        <div class="field">
          <h3 class="ui header">
            支付方式
          </h3>
          <a class="ui basic button">
            <img class="ui small image payment" src="../assets/alipay.svg" alt="" @click="alipay"/>
          </a>
          <a class="ui basic button">
            <img class="ui small image payment" src="../assets/wechat-payment.svg" alt="" @click="wechat_pay"/>
          </a>
        </div>
      </template>
      <template v-else-if="order.refund && !order.refund.refunded && !order.refund.rejected">
        <div class="ui message">
          退款请求正在处理中（1-5个工作日完成）...
        </div>
      </template>
      <div class="mt-10">
        <button class="ui teal button" @click="$router.push({ name: 'files' })">
          返回我的网盘
        </button>
        <button class="ui basic button" @click="$router.push({ name: 'orders' })">
          返回订单列表
        </button>
      </div>
    </div>
    <Modal size="tiny" id="alipay-modal" title="支付宝" hide_footer="true">
      <div v-if="!order || !order.alipay_url" class="my-6">
        <div class="ui active inline loader"></div>
        正在获取支付链接...
      </div>
      <div v-else-if="!paying" class="text-center">
        <a class="my-6 ui teal button" :href="order.alipay_url" target="_blank" @click="paying=true">
          去支付宝页面付款
        </a>
      </div>
      <div v-if="paying" class="text-center">
        <div class="my-6">
          请在打开的页面进行支付...
        </div>
        <button class="ui blue button" @click="refresh_order(); hide_modal('alipay-modal')">支付成功</button>
        <button class="ui button" @click="hide_modal('alipay-modal')">取消</button>
      </div>
    </Modal>
    <Modal size="tiny" id="wechat-pay-modal" title="微信支付" hide_footer="true">
      <div v-if="!order || !order.wechat_pay_url" class="text-center my-6">
        <div class="ui active inline loader"></div>
        正在获取支付链接...
      </div>
      <div class="mx-auto text-center" v-else>
        请用微信扫描二维码支付：
        <img :src="wechat_pay_qrcode_url" class="ui bordered image mx-auto my-8" alt=""/>
        <button class="ui teal button" @click="refresh_order(); hide_modal('wechat-pay-modal')">支付成功</button>
        <button class="ui button" @click="hide_modal('wechat-pay-modal')">关闭</button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Placeholder from '../components/placeholder.vue';
import Modal from '../components/modal.vue';
import QRCode from 'qrcode';

export default {
  name: 'OrderPage',
  props: [],
  components: {
    Placeholder,
    Modal,
  },
  data: function () {
    return {
      order: null,
      refund_reason: "",
      refund_reason_buttons: [
        "点错了",
        "不好用",
        "资源太多用不完",
        "更喜欢别的网盘",
      ],
      paying: false,
    };
  },
  computed: {
    tid() {
      return this.$route.query.tid;
    },
    display_name() {
      return this.order && this.order.plan ? this.order.plan.display_name : null;
    },
  },
  asyncComputed: {
    async wechat_pay_qrcode_url() {
      if (!this.order || !this.order.wechat_pay_url) return null;
      return await QRCode.toDataURL(this.order.wechat_pay_url);
    },
  },
  methods: {
    request_refund(e) {
      if (!this.refund_reason) {
        this.show_error("请填写退款理由（无理由退款请填“无”）");
        if (e)
          e.preventDefault();
        return;
      }
      this.hide_modal('refund-modal');
      this.client.request_refund(this.tid, this.refund_reason).then(() => {
        this.refresh_order();
      }).catch(e => {
        this.show_error(e.response.data);
      });
      this.refund_reason = '';
    },
    refresh_order(payment_method) {
      this.order = null;
      this.$store.dispatch('refresh_userinfo');
      this.client.fetch_order(this.tid, payment_method).then(resp => {
        this.order = resp;
      });
    },
    alipay() {
      this.$gtag.event('purchase', {
        event_label: 'alipay',
        value: this.order.amount,
      });
      if (!this.order.alipay_url) {
        this.refresh_order('alipay');
      }
      this.paying = false;
      this.show_modal('alipay-modal');
    },
    wechat_pay() {
      this.$gtag.event('purchase', {
        event_label: 'wechat',
        value: this.order.amount,
      });
      if (!this.order.wechat_pay_url) {
        this.refresh_order('wechat');
      }
      this.paying = false;
      this.show_modal('wechat-pay-modal');
    },
  },
  mounted() {
    this.refresh_order();
    this.$store.dispatch('refresh_userinfo');
  },
}
</script>

<style scoped>
.payment.image {
  height: 40px;
}
</style>
